<template>
  <block
    component-name="block-grid-contacts"
    body-class="grid grid-cols-12 gap-y-4xl tablet:gap-4xl"
  >
    <template v-slot:default="blockData">
      <card-store-minimal
        v-for="item in blockData.data.items"
        :overline="item.overline"
        :title="item.title"
        :address="item.address"
        :tel="item.tel || undefined"
        :email="item.email || undefined"
        :opening-time="item.opening_time || undefined"
        :website="item.website || undefined"
        :directions="item.directions || undefined"
        class="col-span-full tablet:col-span-6 desktop:col-span-4 w-full"
      />
    </template>
  </block>
</template>
